import { useState } from 'react';

const Contact = () => {
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (message.trim()) {
            // Replace 'your-email@example.com' with your actual email
            const yourEmail = 'Panoiq@gmail.com';
            const subject = 'رسالة من موقعك الإلكتروني';
            const emailBody = encodeURIComponent(message);
            
            // Create mailto link
            const mailtoLink = `mailto:${yourEmail}?subject=${encodeURIComponent(subject)}&body=${emailBody}`;
            
            // Open user's email client
            window.location.href = mailtoLink;
        }
    };

    const styles = {
        container: {
            maxWidth: '600px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f9f9f9',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        },
        title: {
            textAlign: 'center',
            color: '#333',
            marginBottom: '10px',
            fontSize: '2rem'
        },
        subtitle: {
            textAlign: 'center',
            color: '#666',
            marginBottom: '30px',
            fontSize: '1.1rem'
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
        },
        inputGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px'
        },
        label: {
            fontWeight: 'bold',
            color: '#333',
            fontSize: '1rem'
        },
        textarea: {
            padding: '12px',
            border: '2px solid #ddd',
            borderRadius: '5px',
            fontSize: '1rem',
            minHeight: '120px',
            resize: 'vertical',
            transition: 'border-color 0.3s ease',
            outline: 'none',
            fontFamily: 'Arial, sans-serif'
        },
        button: {
            padding: '12px 30px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            alignSelf: 'center'
        },
        note: {
            textAlign: 'center',
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#e9ecef',
            borderRadius: '5px',
            color: '#6c757d'
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>تواصل معنا</h1>
            <p style={styles.subtitle}>إذا كان لديك أي استفسار، لا تتردد في التواصل معنا</p>
            
            <form style={styles.form} onSubmit={handleSubmit}>
                <div style={styles.inputGroup}>
                    <label style={styles.label} htmlFor="message">الرسالة</label>
                    <textarea
                        id="message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={styles.textarea}
                        required
                        placeholder="اكتب رسالتك هنا..."
                    />
                </div>

                <button 
                    type="submit" 
                    style={styles.button}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                >
                    إرسال عبر البريد الإلكتروني
                </button>
            </form>
            
            <div style={styles.note}>
                <p>أو تواصل معنا مباشرة على: <strong>Panoiq@gmail.com</strong></p>
            </div>
        </div>
    );
};

export default Contact;